// extracted by mini-css-extract-plugin
module.exports = {"topBanner":"AnnounceBanner_topBanner__7QXQn","bannerButton":"AnnounceBanner_bannerButton__17dBP"};